<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Dispositivos </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select
        class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label="Ordenação"
        [formControl]="orderControl"
      >
        <option disabled>Ordenar</option>
        <option *ngFor="let order of listOrder" [value]="order.value">{{ order.label }}</option>
      </select>

      <app-status-filter [formControl]="statusControl"></app-status-filter>

      <select
        *ngIf="podeEscolherEmpresa"
        class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label="Filtro de empresa"
        [formControl]="companyControl"
      >
        <option [ngValue]="null">Todas empresas</option>
        <option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</option>
      </select>

      <div>
        <input [formControl]="formInput" type="text" class="form-input w-64" placeholder="Pesquise por Nome" />
      </div>
      <div class="flex justify-between">
        <button
          (click)="filterDevice()"
          title="Filtrar Dispositivos"
          class="px-5 min-w-max btn btn--secondary h-35 ml-5"
        >
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button
          (click)="cleanForm()"
          title="Limpar Filtros"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
      </div>
    </div>
  </div>

  <app-list-devices
    [devices]="devices"
    [kioskRegistrations]="kioskRegistrations"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    (recarregarListagem)="getDevices()"
  ></app-list-devices>

  <hr class="mb-8" />

  <app-add-new-device (reloadDevices)="getDevices()"></app-add-new-device>
</form>
